export default __webpack_public_path__ + "static/form-multiple-action-buttons-do-e676ed8dc604c7b754dc9440eb2d66b634fed209d0dfdc4b949f0f03df9eee09.png";